// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609301442/js/" + chunkId + "." + {"44":"f799b724","225":"5c3baf21","481":"abf71f08","486":"6bfa36a8","770":"6a4669bf"}[chunkId] + ".0.7106298108162985.chunk.js";
};